import { dexpiNodeSchema } from './dexpiNode'
import type {
  DexpiRelationshipField,
  GraphDatapointEdge,
  GraphDexpiEdge,
  GraphEdge,
  GraphNode,
  NodeAppearance,
} from './graphTypes'
import type { PnidNode } from './pnidSchemas'

export type NodeLinks = {
  outgoing: GraphEdge[]
  incoming: GraphDexpiEdge[]
  overlays: NodeAppearance[]
}

function dexpiEdges(
  edges: GraphEdge[],
  field?: DexpiRelationshipField
): GraphDexpiEdge[] {
  return edges.filter(
    (edge): edge is GraphDexpiEdge =>
      edge.kind === 'dexpi' &&
      (field === undefined || edge.data.dexpi_relationship_field === field)
  )
}

export function createGraphNode(entry: PnidNode, links: NodeLinks): GraphNode {
  return {
    id: entry.id,
    tags: entry.tags,
    data: entry.data,
    dexpi: dexpiNodeSchema.parse(entry.data),
    overlays: links.overlays,
    getOutgoingEdges: (): GraphEdge[] => links.outgoing,
    getOutgoingDexpiEdges: (field?: DexpiRelationshipField): GraphDexpiEdge[] =>
      dexpiEdges(links.outgoing, field),
    getIncomingDexpiEdges: (field?: DexpiRelationshipField): GraphDexpiEdge[] =>
      dexpiEdges(links.incoming, field),
    getDatapointEdges: (): GraphDatapointEdge[] =>
      links.outgoing.filter(
        (edge): edge is GraphDatapointEdge =>
          edge.kind === 'datapoint_association'
      ),
    getTargetNodes: (field: DexpiRelationshipField): GraphNode[] =>
      dexpiEdges(links.outgoing, field).map((edge) => edge.targetNode),
    getUniqueTargetNode: (
      field: DexpiRelationshipField
    ): GraphNode | undefined => {
      const edges = dexpiEdges(links.outgoing, field)
      return edges.length === 1 ? edges[0].targetNode : undefined
    },
    getUniqueSourceNode: (
      field: DexpiRelationshipField
    ): GraphNode | undefined => {
      const edges = dexpiEdges(links.incoming, field)
      return edges.length === 1 ? edges[0].sourceNode : undefined
    },
  }
}
